import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { isNil } from 'lodash';

@Component({
  selector: 'app-street-light-planner-step1',
  templateUrl: './street-light-planner-step1.component.html',
  styleUrls: [],
})
export class StreetLightPlannerStep1Component implements AfterViewInit {
  @Input() isRecommendation: boolean | null = null;
  @Output() isRecommendationValueChange = new EventEmitter(true);

  ngAfterViewInit() {
    if (isNil(this.isRecommendation)) {
      setTimeout(() => {
        this.select(true);
      });
    }
  }

  select(value: boolean) {
    this.isRecommendation = value;
    this.isRecommendationValueChange.emit(this.isRecommendation);
  }
}
